import { useModal } from '@/hooks/useModal'
import { ConfirmModal } from '.'

export function useConfirmModal() {
  return useModal(ConfirmModal)
}
